"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.px2vw = void 0;
/** Converts pixels to view-width for easy scalability.
 * @param width defaults to `window.innerWidth`
 */
var px2vw = function (pixels, width) {
    if (width === void 0) { width = window.innerWidth; }
    return (pixels / width) * 100 + "vw";
};
exports.px2vw = px2vw;
//# sourceMappingURL=px2vw.js.map